import { StyleSheet } from 'aphrodite';
import { aceGray, background, borderColor } from '../../../styles/colors';
import { shadowMd } from '../../../styles/shadows';

export const s = StyleSheet.create({
	chatConversation: {
		position: 'relative',
		flex: 1,
		overflowY: 'auto',
		':has(*) > *::-webkit-scrollbar': {
			background: 'transparent',
			width: 8,
			borderRadius: 8,
			height: 10,
		},
		':has(*) > *::-webkit-scrollbar-thumb': {
			backgroundColor: aceGray,
			borderRadius: 10,
			padding: '0 2px',
			width: 6,
		},
	},
	btnScrollToBottom: {
		position: 'absolute',
		bottom: 4,
		left: '50%',
		transform: 'translateX(-50%)',
		borderRadius: `50%`,
		boxShadow: shadowMd,
		display: `inline-flex`,
		height: 36,
		width: 36,
		border: `1px solid ${borderColor}`,
		backgroundColor: background,
		justifyContent: 'center',
		alignItems: 'center',
	},
});
